import React from 'react';

import Column from '@amzn/meridian/column/column';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';

import { Toggle } from 'src/components/Toggle';
import { IVendor } from 'src/types/IVendor';

interface ISubmissionSettingsProps {
    vendor: IVendor;
    isEditMode: boolean;
    handleChange?: (field: string, value: string | boolean) => void;
}

export const SubmissionSettings = ({ vendor, isEditMode, handleChange }: ISubmissionSettingsProps) => {
    return (
        <Column>
            <Heading level={4}>Submission Settings</Heading>
            <Text type="b200" color="secondary">
                Enable or disable the accounting and payments for this vendor
            </Text>
            <Column>
                <Toggle
                    label="Submit Accruals"
                    value={vendor.submitAccruals}
                    isEditMode={isEditMode}
                    onChange={(value) => handleChange && handleChange('submitAccruals', value)}
                />
                <Toggle
                    label="Submit Payments"
                    value={vendor.submitPayments}
                    isEditMode={isEditMode}
                    onChange={(value) => handleChange && handleChange('submitPayments', value)}
                />
            </Column>
        </Column>
    );
};
